export default __webpack_public_path__ + "static/media/img11.3c22d630.png";